/**
 * 교회학교 게시판 상세 페이지
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MainLayout, BoardDetail } from '../../../../shared/components';
import { useBoardDetail } from '../../../../shared/hooks';
import styled from '@emotion/styled';

const PageContainer = styled.div`
  min-height: 400px;
`;

export const SundaySchoolBoardDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // React Query로 게시글 상세 조회 (자동 캐싱)
  const { data: post, isLoading } = useBoardDetail('sunday-school', id ? Number(id) : undefined);

  const handleBack = () => {
    navigate(-1);
  };

  if (!post) {
    return (
      <MainLayout>
        <PageContainer>
        </PageContainer>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <BoardDetail post={post} onBack={handleBack} />
    </MainLayout>
  );
};
